/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React, { Suspense, createContext, useContext } from 'react';
import { Product } from '../../products/storage';

const AddToCartModal = React.lazy(() => import('./AddToCartModal'));

export const AddToCartModalContext = createContext<{
  setProduct: (item: Product | null) => void | null;
  product: Product | null;
}>({
  setProduct: () => null,
  product: null,
});

export const useAddToCartModal = () => useContext(AddToCartModalContext);

type AddToCartProviderProps = {
  children?: React.ReactNode;
};

export const AddToCartProvider: React.FC<AddToCartProviderProps> = ({ children }) => {
  const [product, setProduct] = React.useState<Product | null>(null);

  const value = React.useMemo(() => {
    return {
      setProduct: setProduct,
      product: product,
    };
  }, [product, setProduct]);

  return (
    <AddToCartModalContext.Provider value={value}>
      {children}
      <Suspense>
        <AddToCartModal />
      </Suspense>
    </AddToCartModalContext.Provider>
  );
};

export default AddToCartProvider;
